import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const SAMPLE_REPORT_PDF_PATH = '/exemplo-relatorio-vistoria.pdf';

const DIALOG_TITLE_ID = 'sample-report-pdf-dialog-title';

const SampleReportPdfModal = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    transitionDuration={0}
    aria-labelledby={DIALOG_TITLE_ID}
    slotProps={{
      paper: {
        sx: {
          borderRadius: 2,
          overflow: 'hidden',
        },
      },
    }}
  >
    <DialogTitle
      id={DIALOG_TITLE_ID}
      sx={{
        position: 'relative',
        pr: 6,
        fontFamily: 'GT Haptik, Roboto, sans-serif',
        fontWeight: 600,
        fontSize: 18,
      }}
    >
      Exemplo de relatório
      <IconButton
        aria-label="Fechar"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: 'grey.500',
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers sx={{ p: 0 }}>
      <Box
        component="iframe"
        src={SAMPLE_REPORT_PDF_PATH}
        title="Exemplo de relatório de vistoria"
        sx={{
          display: 'block',
          width: '100%',
          height: '70vh',
          minHeight: 480,
          border: 0,
        }}
      />
    </DialogContent>
  </Dialog>
);

export default SampleReportPdfModal;
